var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("article", { staticClass: "box" }, [
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column" }, [
              _c("p", { staticClass: "title" }, [
                _c("span", { staticClass: "has-badge-child-offset2" }, [
                  _vm._v("Images"),
                ]),
                _vm.imageCount
                  ? _c("span", {
                      staticClass:
                        "has-badge-rounded has-badge-info has-badge-large",
                      attrs: { "data-badge": _vm.imageCount },
                    })
                  : _vm._e(),
              ]),
              _c("p", { staticClass: "subtitle" }, [
                _vm._v(
                  _vm._s(
                    _vm.isDropzoneActive
                      ? "Upload images"
                      : "Manage quote images"
                  )
                ),
              ]),
            ]),
            _c("div", { staticClass: "column is-narrow" }, [
              _c("p", { staticClass: "buttons" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasSelected,
                        expression: "hasSelected",
                      },
                    ],
                    staticClass: "button tooltip is-tooltip-bottom",
                    attrs: { "data-tooltip": "Move Category" },
                    on: { click: _vm.showMoveImageDialog },
                  },
                  [_vm._m(0)]
                ),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasSelected,
                        expression: "hasSelected",
                      },
                    ],
                    staticClass: "button tooltip is-tooltip-bottom",
                    attrs: { "data-tooltip": "Copy to quote" },
                    on: { click: _vm.showCopyImageDialog },
                  },
                  [_vm._m(1)]
                ),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasSelected,
                        expression: "hasSelected",
                      },
                    ],
                    staticClass: "button tooltip is-tooltip-bottom",
                    attrs: { "data-tooltip": "Delete selected" },
                    on: { click: _vm.showDeletAllModal },
                  },
                  [_vm._m(2)]
                ),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasSelected,
                        expression: "hasSelected",
                      },
                    ],
                    staticClass: "button tooltip is-tooltip-bottom",
                    attrs: { "data-tooltip": "Download selected" },
                    on: { click: _vm.showDownloadImagesModal },
                  },
                  [_vm._m(3)]
                ),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isDropzoneActive,
                        expression: "!isDropzoneActive",
                      },
                    ],
                    staticClass: "button tooltip is-tooltip-bottom",
                    attrs: {
                      "data-tooltip": "Select all",
                      disabled: _vm.isLoadingImages,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setSelectedStatusAll(true)
                      },
                    },
                  },
                  [_vm._m(4)]
                ),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isDropzoneActive,
                        expression: "!isDropzoneActive",
                      },
                    ],
                    staticClass: "button tooltip is-tooltip-bottom",
                    attrs: { "data-tooltip": "Deselect all" },
                    on: {
                      click: function ($event) {
                        return _vm.setSelectedStatusAll(false)
                      },
                    },
                  },
                  [_vm._m(5)]
                ),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isDropzoneActive,
                        expression: "!isDropzoneActive",
                      },
                    ],
                    staticClass: "button tooltip is-tooltip-bottom",
                    attrs: {
                      "data-tooltip": "Refresh",
                      disabled: _vm.isLoadingImages,
                    },
                    on: { click: _vm.getThumbnails },
                  },
                  [_vm._m(6)]
                ),
                _vm.canEditCategory
                  ? _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isDropzoneActive,
                            expression: "!isDropzoneActive",
                          },
                        ],
                        staticClass: "button is-primary",
                        on: {
                          click: function ($event) {
                            return _vm.toggleImageCategory(true)
                          },
                        },
                      },
                      [_vm._m(7), _c("span", [_vm._v("Add Categories")])]
                    )
                  : _vm._e(),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isDropzoneActive && _vm.uploadedImage,
                        expression: "isDropzoneActive && uploadedImage",
                      },
                    ],
                    staticClass: "button is-primary",
                    on: {
                      click: function ($event) {
                        return _vm.clearUploadedFile(true)
                      },
                    },
                  },
                  [_vm._m(8), _c("span", [_vm._v("Clear All")])]
                ),
                _c(
                  "a",
                  {
                    staticClass: "button is-primary",
                    on: {
                      click: function ($event) {
                        return _vm.uploadImage()
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _c("i", {
                        staticClass: "mdi",
                        class: {
                          "mdi-plus": !_vm.isDropzoneActive,
                          "mdi-minus": _vm.isDropzoneActive,
                        },
                      }),
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.isDropzoneActive ? "Close" : "Add")),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isDropzoneActive && _vm.isMobile.any(),
                  expression: "isDropzoneActive && isMobile.any()",
                },
              ],
              staticClass: "field",
            },
            [
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.dropzoneOptions.capture,
                          expression: "dropzoneOptions.capture",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.dropzoneOptions,
                            "capture",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "option",
                        {
                          domProps: {
                            value: _vm.mobileImageSourceType.Gallery,
                          },
                        },
                        [_vm._v("From Gallery")]
                      ),
                      _c(
                        "option",
                        {
                          domProps: { value: _vm.mobileImageSourceType.Camera },
                        },
                        [_vm._v("From Camera")]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isDropzoneActive,
                  expression: "isDropzoneActive",
                },
              ],
              staticClass: "card-image",
            },
            [
              _c("div", [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Select Image Category"),
                ]),
                _c("div", { staticClass: "select field mb-2" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedCategory,
                          expression: "selectedCategory",
                        },
                      ],
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedCategory = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.clearUploadedFile,
                        ],
                      },
                    },
                    _vm._l(_vm.imageCategories, function (cat) {
                      return _c(
                        "option",
                        {
                          key: cat.quoteImageCategoryId,
                          domProps: { value: cat.quoteImageCategoryId },
                        },
                        [_vm._v(" " + _vm._s(cat.name) + " ")]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
              _vm.isDropzoneActive
                ? _c("vue-dropzone", {
                    ref: "quoteImageDropzone",
                    attrs: {
                      id: "quoteImageDropzone",
                      "use-custom-slot": true,
                      options: _vm.dropzoneOptions,
                    },
                    on: {
                      "vdropzone-mounted": _vm.dropzoneMounted,
                      "vdropzone-file-added": _vm.dropzoneFileAdded,
                      "vdropzone-success": _vm.dropzoneSuccess,
                      "vdropzone-error-multiple": _vm.dropzoneErrorMultiple,
                      "vdropzone-sending": _vm.dropzoneSending,
                      "vdropzone-total-upload-progress":
                        _vm.dropzoneTotalUploadProgress,
                      "vdropzone-complete-multiple":
                        _vm.dropzoneCompleteMultiple,
                      "vdropzone-queue-complete": (file) =>
                        _vm.dropzoneQueueComplete(file),
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isDropzoneActive,
                  expression: "!isDropzoneActive",
                },
              ],
            },
            [
              _vm._l(_vm.imageCategories, function (category) {
                return [
                  _vm.refreshComponent
                    ? _c("quote-image-category", {
                        key: category.quoteImageCategoryId,
                        ref: "quoteImageCategories",
                        refInFor: true,
                        attrs: {
                          categories: _vm.imageCategories,
                          images: _vm.imagesWithInfo,
                          "quote-id": _vm.value.quoteId,
                          category: category.name,
                          "category-id": category.quoteImageCategoryId,
                          "category-order-index": category.orderIndex,
                          "is-private": category.isPrivate,
                          value: _vm.value,
                          "has-select": _vm.hasSeclectAll,
                          refresh: _vm.refreshCategory,
                        },
                        on: {
                          setPrimary: (imageId) => _vm.setPrimary(imageId),
                          "update-image": _vm.updateImage,
                          "arrange-images-order": _vm.arrangeImagesOrder,
                        },
                      })
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ]),
      ]),
      _c(
        "confirm-modal",
        {
          attrs: {
            active: _vm.isDeleteAllModalActive,
            "ok-text": "Yes",
            "cancel-text": "No",
          },
          on: {
            "update:active": function ($event) {
              _vm.isDeleteAllModalActive = $event
            },
            ok: function ($event) {
              return _vm.deleteSelectedImages(true)
            },
            cancel: function ($event) {
              return _vm.deleteSelectedImages(false)
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Delete images"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _c(
              "span",
              { staticClass: "has-text-primary has-text-weight-bold" },
              [_vm._v(_vm._s(_vm.selectedCount))]
            ),
            _vm._v(" selected images will be deleted. Continue? "),
          ]),
        ]
      ),
      _c(
        "confirm-modal",
        {
          attrs: {
            active: _vm.isDownloadImagesModalActive,
            "ok-text": "Yes",
            "cancel-text": "No",
          },
          on: {
            "update:active": function ($event) {
              _vm.isDownloadImagesModalActive = $event
            },
            ok: function ($event) {
              return _vm.downloadSelectedImages(true)
            },
            cancel: function ($event) {
              return _vm.downloadSelectedImages(false)
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Download images"),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _c(
              "span",
              { staticClass: "has-text-primary has-text-weight-bold" },
              [_vm._v(_vm._s(_vm.selectedCount))]
            ),
            _vm._v(" selected images will be downloaded. Continue? "),
          ]),
        ]
      ),
      _c("quote-image-category-modal", {
        attrs: { active: _vm.addCategoryModalOpen },
        on: {
          cancel: function ($event) {
            return _vm.toggleImageCategory(false)
          },
          "categories-changed": function ($event) {
            return _vm.onImageCategoriesChanged()
          },
        },
      }),
      _vm.isCopyImageModalActive
        ? _c("quote-no-search-modal", {
            attrs: { active: _vm.isCopyImageModalActive },
            on: {
              "update:active": function ($event) {
                _vm.isCopyImageModalActive = $event
              },
              copy: _vm.copyImagesToQuote,
              close: _vm.closeCopyImageModal,
            },
          })
        : _vm._e(),
      _c(
        "confirm-modal",
        {
          attrs: {
            active: _vm.isMoveSelectedImages,
            "ok-text": "Yes",
            "cancel-text": "No",
          },
          on: {
            "update:active": function ($event) {
              _vm.isMoveSelectedImages = $event
            },
            ok: function ($event) {
              return _vm.moveSelectedImages(true)
            },
            cancel: function ($event) {
              return _vm.moveSelectedImages(false)
            },
          },
        },
        [
          _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
            _vm._v("Move to category"),
          ]),
          _c("div", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Select Image Category"),
            ]),
            _c("div", { staticClass: "select field mb-2" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedCategory,
                      expression: "selectedCategory",
                    },
                  ],
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedCategory = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.getMovableImageCategories(), function (cat) {
                  return _c(
                    "option",
                    {
                      key: cat.quoteImageCategoryId,
                      domProps: { value: cat.quoteImageCategoryId },
                    },
                    [_vm._v(" " + _vm._s(cat.name) + " ")]
                  )
                }),
                0
              ),
            ]),
          ]),
          _c("p", { attrs: { slot: "text-content" }, slot: "text-content" }, [
            _c(
              "span",
              { staticClass: "has-text-primary has-text-weight-bold" },
              [_vm._v(_vm._s(_vm.selectedCount))]
            ),
            _vm._v(
              " selected images will be moved to selected Category. Continue? "
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("i", { staticClass: "mdi mdi-folder-move mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("i", { staticClass: "mdi mdi-content-copy mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-danger" }, [
      _c("i", { staticClass: "mdi mdi-delete-sweep mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("i", { staticClass: "mdi mdi-download mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-success" }, [
      _c("i", { staticClass: "mdi mdi-select-all mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-grey" }, [
      _c("i", { staticClass: "mdi mdi-select-off mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-refresh mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-18px mdi-plus" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-18px mdi-close" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }